// extracted by mini-css-extract-plugin
export default {"CtaButtons":"CtaButtons-module__CtaButtons__ImeSlZW","Button":"CtaButtons-module__Button__OJGawUs"};